// Caps of the redaction editor / request search, shared by the server validators
// (400 before a workflow exists), the client forms (maxLength / hints) and — by the
// parity test in contracts/tests/limits.contracts.test.js — the job contracts
// (annotations.maxItems, text/query/reason maxLength, files/results maxItems).
// Change a number here and the test tells you which schema to update.
export const MAX_REDACTION_ANNOTATIONS = 5000
export const MAX_REDACTION_REASON_LENGTH = 2000
export const REDACTION_SEARCH_TEXT_LENGTH = { min: 2, max: 200 }
export const REQUEST_SEARCH_QUERY_LENGTH = { min: 2, max: 200 }
export const SEARCH_MAX_FILES = 2000
export const SEARCH_MAX_RESULTS = 100
